import React, { Component } from 'react';

export default class Group extends Component {
    render() {
        return (
            <g transform={"translate(" + this.props.x + "," + this.props.y + ")"}>
                {this.props.children}
            </g>
        );
    }
}
